import { normalizeSiteLanguage } from "../i18n/language";

/** Official free HEXACO-PI-R survey (University of Calgary). */
export const HEXACO_OFFICIAL_TEST_URL =
  "https://survey.ucalgary.ca/jfe/form/SV_0DHbQPy5Vr0TAlE";

/** Display price for HEXACO data interpretation report (HKD). */
export const HEXACO_REPORT_PRICE_HKD = 600;

/** Align with Alibaba traditional API Gateway serverless request body limit (8 MB). */
export const HEXACO_UPLOAD_MAX_BYTES = 8 * 1024 * 1024;

export const HEXACO_UPLOAD_MAX_MB = HEXACO_UPLOAD_MAX_BYTES / (1024 * 1024);

/** Set `REACT_APP_HEXACO_WEB_PURCHASE_ENABLED=false` to hide the web purchase CTA. */
export const isHexacoWebPurchaseEnabled =
  process.env.REACT_APP_HEXACO_WEB_PURCHASE_ENABLED !== "false";

const HEXACO_SAMPLE_BASE = "https://appconfig.deepsoulai.com/hexaco_sample";

export const HEXACO_FREE_TEST_SAMPLE_PDF_URL = `${HEXACO_SAMPLE_BASE}/hexaco_sample_report.pdf`;

export const HEXACO_VALID_PDF_GUIDE_IMAGE_URL =
  "/images/hexaco/hexaco_valid_pdf_guide.jpeg";

export function getHexacoDetailedSampleReportUrl(
  language?: string | null,
): string {
  const siteLanguage = normalizeSiteLanguage(language);
  if (siteLanguage === "en") {
    return `${HEXACO_SAMPLE_BASE}/hexaco_detail_report_en.pdf`;
  }
  if (siteLanguage === "zh-CN") {
    return `${HEXACO_SAMPLE_BASE}/hexaco_detail_report_zh_hans.pdf`;
  }
  return `${HEXACO_SAMPLE_BASE}/hexaco_detail_report_zh_hk.pdf`;
}
